module.exports = __webpack_public_path__ + "static/media/qr_code_app.6c57d136.png";